import { Avatar, ListRow, getInitials, tintForId } from "@/ui";
import { formatRatingDelta, formatRelative } from "@/lib/format";
import { useOpenUserProfile } from "@/features/users/UserProfileSheetProvider";
import type { MatchHistoryItem } from "@/features/queries";

export function MatchHistoryRow({ match }: { match: MatchHistoryItem }) {
  const openProfile = useOpenUserProfile();
  const won = match.won;
  const scoreColor = won ? "var(--brand-orange)" : "var(--fg2)";
  const deltaColor = won ? "var(--brand-orange)" : "var(--fg-danger)";

  const name =
    match.opponent_first_name ?? match.opponent_username ?? "Соперник";

  return (
    <ListRow
      onClick={() => openProfile(match.opponent_id)}
      leading={
        <Avatar
          initials={getInitials(match.opponent_first_name, null, match.opponent_username)}
          size={36}
          tint={tintForId(match.opponent_id)}
          src={match.opponent_photo_url}
        />
      }
      title={name}
      subtitle={formatRelative(match.played_at)}
      trailing={
        <div style={{ textAlign: "right", fontFamily: "var(--font-display)" }}>
          <div
            style={{
              fontSize: 17,
              fontWeight: 700,
              color: scoreColor,
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {match.my_score}–{match.opponent_score}
          </div>
          <div
            style={{
              fontSize: 12,
              color: deltaColor,
              fontFamily: "var(--font-body)",
              fontWeight: 600,
            }}
          >
            {formatRatingDelta(match.rating_change)}
          </div>
        </div>
      }
    />
  );
}
